/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Loading_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Loading style guides" |
*
* @param {Style_Guide_Loading_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_loading_aria_label = /** @type {((inputs?: Style_Guide_Loading_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Loading_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chargement des guides de style")
	if (locale === "de") return /** @type {LocalizedString} */ ("Lade-Styleguides")
	if (locale === "it") return /** @type {LocalizedString} */ ("Caricamento delle guide di stile")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Руководства по стилю загрузки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cargando guías de estilo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("加载样式指南")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スタイルガイドを読み込んでいます")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्टाइल गाइड लोड हो रही हैं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Carregando guias de estilo")
	return /** @type {LocalizedString} */ ("Loading style guides")
});